import {
  Box,
  Typography,
  Paper,
  Container,
  Stack,
  Chip,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { RestaurantMenu, Schedule, Info } from "@mui/icons-material";
import Navbar from "../../Navbar";
import { useNavigate } from "react-router-dom";

export default function PantallaNoHayViandas() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper
          elevation={3}
          sx={{
            p: 6,
            textAlign: "center",
            borderRadius: 3,
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative background elements */}
          <Box
            sx={{
              position: "absolute",
              top: -50,
              right: -50,
              width: 100,
              height: 100,
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.1)",
              zIndex: 0,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -30,
              left: -30,
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "rgba(255, 255, 255, 0.1)",
              zIndex: 0,
            }}
          />

          <Stack
            spacing={4}
            alignItems="center"
            sx={{ position: "relative", zIndex: 1 }}
          >
            {/* Icon */}
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 32px rgba(102, 126, 234, 0.3)",
              }}
            >
              <RestaurantMenu sx={{ fontSize: 40, color: "white" }} />
            </Box>

            {/* Status chip */}
            <Chip
              icon={<Schedule />}
              label="En preparación"
              color="warning"
              variant="filled"
              sx={{
                px: 2,
                py: 1,
                fontSize: "0.9rem",
                fontWeight: 600,
              }}
            />

            {/* Main title */}
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: "#2d3748",
                mb: 2,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Viandas de la Semana
            </Typography>

            {/* Main message */}
            <Typography
              variant="h6"
              sx={{
                color: "#4a5568",
                fontWeight: 500,
                lineHeight: 1.6,
                maxWidth: 500,
              }}
            >
              Aún no se cargó el menú de esta semana.
            </Typography>

            {/* Additional info */}
            <Box
              sx={{
                background: "rgba(255, 255, 255, 0.7)",
                borderRadius: 2,
                p: 3,
                border: "1px solid rgba(255, 255, 255, 0.3)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                sx={{ mb: 2 }}
              >
                <Info sx={{ color: "#667eea", fontSize: 20 }} />
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: "#2d3748",
                  }}
                >
                  Información
                </Typography>
              </Stack>
              <Typography
                variant="body1"
                sx={{
                  color: "#718096",
                  lineHeight: 1.6,
                }}
              >
                Subimos el menú semanal los jueves al mediodía o a la tarde. Te
                avisaremos por SMS cuando esté disponible
              </Typography>
            </Box>

            <Button
              startIcon={<HomeIcon />}
              sx={{ fontStyle: "italic" }}
              onClick={() => navigate("/navbar")}
            >
              Volver al menu principal
            </Button>
          </Stack>
        </Paper>
      </Container>
    </>
  );
}
